export default {
  products: 'المنتجات',
  resources: 'الموارد',
  support: 'الدعم',
  downloadApp: 'تحميل التطبيق',
  followUs: 'تابع تأميني',
  languageToggle: 'English',
  login: 'الدخول لحسابي',
  logout: 'تسجيل الخروج',
  myAccount: 'حسابي',
  accountSettings: 'إعدادات الحساب',
  myDashboard: 'لوحة بياناتي',
} as const
